import { Grid, useMediaQuery } from "@material-ui/core";
import React from "react";
import SimpleReactLightbox, { SRLWrapper } from "simple-react-lightbox";
// import { StyleProvider } from "../../contexts/StyleContext";

// import ResponsiveGallery from "react-responsive-gallery";

const Photos = ({ snaps }) => {
    const mobileDevice = useMediaQuery('(max-width:670px)');
    // const darkPref = window.matchMedia("(prefers-color-scheme: dark)");
    // const [isDark, setIsDark] = useLocalStorage("isDark", darkPref.matches);

    // const changeTheme = () => {
    //     setIsDark(!isDark);
    // };
    // const [toggler, setToggler] = useState(false);
    //   useEffect(() => {
    //     import ResponsiveGallery from "react-responsive-gallery";
    //   }, [window]);


    console.log(typeof window);




    return (
        <SimpleReactLightbox >
            <SRLWrapper >
                <Grid container style={{ justifyContent: 'center', }}>
                    {snaps?.map((image, index) => (
                        <Grid item md={4} key={index}>
                            <a href={image.src} style={{ padding: "1%" }}>
                                <img
                                    src={image.src}
                                    alt=""
                                    style={{ width: mobileDevice ? 280 : 350, height: 200, marginBottom: 10, boxShadow: 'rgb(0 0 0 / 20%) 0px 2px 1px -1px, rgb(0 0 0 / 14%) 0px 1px 1px 0px, rgb(0 0 0 / 12%) 0px 1px 3px 0px', border: '1px solid #003e77', borderRadius: 6 }}
                                />
                            </a>
                        </Grid>
                    ))}
                </Grid>
            </SRLWrapper>
        </SimpleReactLightbox>

    );
};

export default Photos;
